import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { EntityRecordsTable, SectionTitle } from "../../shared";

const INCIDENT_COLUMNS = [
    { key: "index", label: "#", width: "6%" },
    { key: "type", label: "Type", width: "22%" },
    { key: "secondaryId", label: "Secondary ID", width: "24%" },
    { key: "status", label: "Status", width: "24%" },
    { key: "submissionDate", label: "Submission Date", width: "24%" },
];

const RelatedIncidentsSection = ({ supplierData = {}, meta }) => {
    const relatedIncidents = Array.isArray(supplierData?.relatedIncidents)
        ? supplierData.relatedIncidents
        : [];

    const records = relatedIncidents.map((incident, index) => ({
        id: incident?.id || `incident-${index}`,
        index: index + 1,
        type: incident?.type || "Incident",
        secondaryId: incident?.secondaryId,
        status: incident?.status,
        submissionDate: incident?.submissionDate,
    }));

    return (
        <View style={styles.wordSectionContent}>
            <EntityRecordsTable
                columns={INCIDENT_COLUMNS}
                records={records}
                leading={(
                    <SectionTitle
                        title={meta?.title || "Related Incidents"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
            />
        </View>
    );
};

export default withNamespaces()(RelatedIncidentsSection);
